const routes = {
  user: {
    profile: '/profile',
    settings: '/settings',
    help: '/help',
  },
  admin: {
    index: '/admin',
    whiteLabel: '/admin/app-configs',
  },
  notifications: '/notifications',
  events: {
    share: (eventId: string, invitationToken: string) => `/events/${eventId}/enter/${invitationToken}`,
  },
  // TODO rearange routes to better fit the structure
  contentObjects: {
    posts(id: string) {
      return `/posts/${id}`;
    },
    activities(id: string) {
      return `/activities/${id}`;
    },
    polls(id: string) {
      return `/polls/${id}`;
    },
    kudos(id: string) {
      return `/kudos/${id}`;
    },
    events(id: string) {
      return `/events/${id}/about`;
    },
    campaigns(id: string, organizationId: string) {
      return `/campaigns/listing/${organizationId}/${id}`;
    },
    withingsOrderPosts(id: string) {
      return `/withings_order_posts/${id}`;
    },
  },
  community: {
    feed(id: string) {
      return `/communities/${id}/feed`;
    },
  },
  program: {
    timeline(id: string) {
      return `/courses/${id}/timeline`;
    },
    about(id: string) {
      return `/courses/${id}/about`;
    },
  },
};

export default routes;
